<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="iq-card mb-0" style="min-width: 300px;">
    <div class="iq-card-header d-flex justify-content-between">
      <div class="iq-header-title">
        <h4 class="card-title" v-if="!data.lndmId">Add New Landmark</h4>
      </div>
    </div>
    <div class="iq-card-body">
      <div class="row mb-3">
        <div role="group" class="form-group col-md-6">
          <label for="lndmName" class="d-block form-label text-left">
            Name:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                id="lndmName"
                placeholder="Landmark Name"
                v-model="data.lndmName"
                :class="errors.lndmName ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmName">
                {{ Object.values(errors.lndmName) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="lndmType" class="d-block form-label text-left">
            Type:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <select
                class="form-control"
                id="lndmType"
                v-model="data.lndmType"
                :class="errors.lndmType ? 'is-invalid' : ''"
              >
                <option value="">Select Type</option>
                <option value="port">PORT</option>
                <option value="jetty">JETTY</option>
                <option value="sea">SEA</option>
              </select>
              <b-form-invalid-feedback v-if="errors.lndmType">
                {{ Object.values(errors.lndmType) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-12">
          <label for="lndmDescription" class="d-block form-label text-left">
            Description:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <textarea
                class="form-control"
                id="lndmDescription"
                rows="3"
                placeholder="Description"
                v-model="data.lndmDescription"
                :class="errors.lndmDescription ? 'is-invalid' : ''"
              ></textarea>
              <b-form-invalid-feedback v-if="errors.lndmDescription">
                {{ Object.values(errors.lndmDescription) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-6">
          <label for="lndmLatitude" class="d-block form-label text-left">
            Latitude:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                id="lndmLatitude"
                placeholder="-6.12345678"
                v-model="data.lndmLatitude"
                readonly
                :class="errors.lndmLatitude ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmLatitude">
                {{ Object.values(errors.lndmLatitude) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="lndmLongitude" class="d-block form-label text-left">
            Longitude:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                id="lndmLongitude"
                placeholder="106.12345678"
                v-model="data.lndmLongitude"
                readonly
                :class="errors.lndmLongitude ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.lndmLongitude">
                {{ Object.values(errors.lndmLongitude) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div role="group" class="form-group col-md-12">
          <label class="d-block form-label text-left">
            Pick Location:
          </label>
          <div class="text-muted small">Click the map to fill latitude and longitude.</div>
          <div ref="landmarkMap" class="landmark-form-map mt-2"></div>
        </div>
      </div>

      <div class="form-group">
        <b-button
          @click="onCancelAddClicked"
          class="mr-1"
          size="sm"
          :disabled="isSubmit"
          variant="outline-danger"
        >
          <div class="mx-2">Cancel</div>
        </b-button>
        <b-button
          type="submit"
          @click="onSubmitClicked"
          :disabled="isSubmit || !isFormComplete"
          variant="primary"
          size="sm"
          class="ml-1"
        >
          <div class="mx-2">
            <i v-if="isSubmit" class="ri-loader-line"></i>
            Submit
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'LandmarkForm',
  props: ['data', 'errors', 'isSubmit'],
  data() {
    return {
      map: null,
      marker: null,
      markerIcon: null,
    };
  },
  computed: {
    isCreate() {
      return !this.data.lndmId;
    },
    isFormComplete() {
      const name = (this.data.lndmName || '').trim();
      const type = (this.data.lndmType || '').trim();
      const lat = (this.data.lndmLatitude || '').toString().trim();
      const lng = (this.data.lndmLongitude || '').toString().trim();
      return !!(name && type && lat && lng);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
      this.marker = null;
    }
  },
  watch: {
    'data.lndmId': function dataLndmId() {
      if (!this.map) {
        this.$nextTick(() => {
          this.initMap();
        });
      } else {
        this.centerMapFromData();
      }
    },
    'data.lndmLatitude': function dataLndmLatitude(value) {
      this.syncMarkerFromInput(value, this.data.lndmLongitude);
      this.centerMapFromData();
    },
    'data.lndmLongitude': function dataLndmLongitude(value) {
      this.syncMarkerFromInput(this.data.lndmLatitude, value);
      this.centerMapFromData();
    },
  },
  methods: {
    onCancelAddClicked() {
      this.$emit('onCancelAddClicked');
    },
    onSubmitClicked() {
      if (!this.isFormComplete) {
        return;
      }
      const data = { ...this.data };
      this.$emit('onSubmitClicked', data);
    },
    initMap() {
      if (this.map || !this.$refs.landmarkMap || typeof L === 'undefined') {
        return;
      }
      const lat = parseFloat(this.data.lndmLatitude) || -6.2;
      const lng = parseFloat(this.data.lndmLongitude) || 106.816666;
      const map = L.map(this.$refs.landmarkMap).setView([lat, lng], 5);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(map);
      this.map = map;
      this.markerIcon = L.icon({
        iconUrl: '/marker/pinpoint.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
      this.setMarker(lat, lng);
      map.on('click', (event) => {
        if (!event || !event.latlng) {
          return;
        }
        const { lat: clickLat, lng: clickLng } = event.latlng;
        this.updateCoordinates(clickLat, clickLng);
      });
      setTimeout(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      }, 0);
    },
    centerMapFromData() {
      if (!this.map) {
        return;
      }
      const lat = parseFloat(this.data.lndmLatitude);
      const lng = parseFloat(this.data.lndmLongitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      this.map.setView([lat, lng], 12);
    },
    setMarker(lat, lng) {
      if (!this.map) {
        return;
      }
      const position = [lat, lng];
      if (this.marker) {
        this.marker.setLatLng(position);
      } else {
        this.marker = L.marker(position, {
          icon: this.markerIcon || undefined,
        }).addTo(this.map);
      }
    },
    updateCoordinates(lat, lng) {
      const nextLat = Number(lat).toFixed(8);
      const nextLng = Number(lng).toFixed(8);
      this.$set(this.data, 'lndmLatitude', nextLat);
      this.$set(this.data, 'lndmLongitude', nextLng);
      this.setMarker(lat, lng);
    },
    syncMarkerFromInput(latValue, lngValue) {
      if (!this.map) {
        return;
      }
      const lat = parseFloat(latValue);
      const lng = parseFloat(lngValue);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      this.setMarker(lat, lng);
    },
  },
};
</script>

<style scoped>
.landmark-form-map {
  width: 100%;
  height: 280px !important;
  border-radius: 8px;
}
</style>
